import type { Complaint } from '../types/care';

const UPLOADS = 'https://excellentcareclinics.nl/wp-content/uploads';

/** The 12 pain complaints from the current Pijnbehandelingen page, with the same photos. */
export const complaints: Complaint[] = [
  {
    slug: 'hoofdpijn-migraine',
    title: 'Hoofdpijn, migraine',
    image: `${UPLOADS}/2023/07/Depositphotos_294445324_L.jpg`,
    description: [
      'De zenuwen die een rol kunnen spelen bij hoofdpijnklachten lopen vanuit de nek aan beide kanten naar het achterhoofd. Irritatie van deze zenuwen kan hoofdpijn geven, mogelijk ook in het voorhoofd.',
      'Migraine kan leiden tot hevige hoofdpijn, misselijkheid en overgevoeligheid voor licht en geluid, en kan het dagelijks functioneren aanzienlijk beperken.',
    ],
    treatmentSlugs: ['occipitaal-blokkade', 'pre-empt', 'botox-infiltratie', 'sphenopalatinum-blokkade'],
  },
  {
    slug: 'aangezichtspijn-trigeminusneuralgie',
    title: 'Aangezichtspijn, trigeminusneuralgie',
    image: `${UPLOADS}/2023/05/depositphotos_75108713-stock-photo-woman-toothache-1.webp`,
    description: [
      'Trigeminusneuralgie is een vorm van aangezichtspijn met heftige, schietende, elektrische pijnscheuten in het gebied van de aangezichtszenuw. Typisch is dat de pijn wordt opgewekt door een normaal onschuldige prikkel, zoals aanraken, eten of praten.',
    ],
    treatmentSlugs: ['sweet-procedure', 'foramen-ovale', 'sphenopalatinum-blokkade', 'masseter-infiltratie', 'botox-infiltratie'],
  },
  {
    slug: 'nekpijn-hernia',
    title: 'Nekpijn, uitstralingspijn in arm, hernia',
    image: `${UPLOADS}/2023/07/depositphotos_281140374-stock-photo-neck-pain-man-suffering-from.webp`,
    description: [
      'Bij nekpijn met uitstraling naar schouder of arm kan een zenuwwortelblokkade worden toegepast: een verdovend en een irritatieremmend medicijn worden rondom de zenuwwortel gespoten.',
    ],
    treatmentSlugs: ['zenuwwortel-nek', 'epidurale-injectie', 'trapezius-infiltratie', 'supra-scapularis'],
  },
  {
    slug: 'carpaal-tunnel-syndroom',
    title: 'Carpaal tunnel syndroom',
    image: `${UPLOADS}/2023/07/Depositphotos_449020518_L.jpg`,
    description: [
      'Het carpaal tunnel syndroom ontstaat doordat de middenhandszenuw (nervus medianus) bekneld raakt in de pols. Door de carpale tunnel lopen ook de pezen van de vingers; een zwelling in deze tunnel geeft druk op de zenuw.',
    ],
    treatmentSlugs: ['carpaal-tunnel-hydrodissectie'],
  },
  {
    slug: 'rugpijn-hernia',
    title: 'Rugpijn, uitstralingspijn in been, hernia',
    image: `${UPLOADS}/2023/07/depositphotos_281140346-stock-photo-kidney-stones-pain-in-a.webp`,
    description: [
      'Bij rugpijn met uitstraling naar het been kan een geprikkelde zenuwwortel de oorzaak zijn. Ook verklevingen of littekenweefsel rond een zenuwwortel, bijvoorbeeld na een hernia of operatie, kunnen uitstralende zenuwpijn geven.',
    ],
    treatmentSlugs: ['zenuwwortel-rug', 'epidurale-injectie', 'caudale-injectie', 'racz'],
  },
  {
    slug: 'buikpijn-acnes',
    title: 'Buikpijn, ACNES',
    image: `${UPLOADS}/2023/07/Depositphotos_310471518_S.jpg`,
    description: [
      'Bij het buikwandpijnsyndroom ACNES ontstaat pijn doordat huidtakjes van de tussenribzenuwen bekneld raken in de buikwand. De pijn is met één vinger aan te wijzen, verergert bij inspanning van de buikspieren en vermindert bij ontspanning.',
    ],
    treatmentSlugs: ['acnes', 'qutenza', 'tens'],
  },
  {
    slug: 'littekenpijn',
    title: 'Littekenpijn',
    image: `${UPLOADS}/2023/05/Depositphotos_200653566_L.jpg`,
    description: ['Aanhoudende pijn in of rond een litteken.'],
    treatmentSlugs: ['intercostaal-blokkade', 'ilio-inguinalis', 'qutenza', 'triggerpoint-injectie'],
  },
  {
    slug: 'pudendus-neuralgie',
    title: 'Pudendus neuralgie',
    image: `${UPLOADS}/2023/05/depositphotos_272166432-stock-photo-woman-in-a-red-dress.webp`,
    description: [
      'Bij pudendus neuralgie is de schaamzenuw bekneld of beschadigd. Dit kan klachten geven rond de geslachtsorganen, de liezen en de binnenkant van de bovenbenen, zoals pijn of een brandend gevoel, pijn aan het zitbeen of een tintelend gevoel bij zitten.',
    ],
    treatmentSlugs: ['pudendus-blokkade', 'parasacraal-blokkade'],
  },
  {
    slug: 'bilpijn-piriformissyndroom',
    title: 'Bilpijn, piriformissyndroom',
    image: `${UPLOADS}/2023/05/depositphotos_240490518-stock-photo-woman-suffering-hemorrhoids-anal-pain-1.webp`,
    description: [
      'De piriformisspier loopt van het heiligbeen naar het dijbeen. Als de spier gezwollen is of verkrampt, kan zij geïrriteerd raken. U kunt dan zeurende pijn diep in de bil hebben, met uitstraling naar de rug en de achterkant van het dijbeen tot in de knieholte.',
    ],
    treatmentSlugs: ['piriformis-blokkade', 'botox-infiltratie'],
  },
  {
    slug: 'kniepijn',
    title: 'Kniepijn',
    image: `${UPLOADS}/2023/05/depositphotos_40843623-stock-photo-knee-pain.webp`,
    description: [
      'Door slijtage (artrose) of na een knieprothese kan chronische kniepijn ontstaan. Het gevoel in de knie wordt verzorgd door drie zogenaamde geniculaire zenuwen.',
    ],
    treatmentSlugs: ['geniculair-blokkade', 'durolane'],
  },
  {
    slug: 'neuropathie-polyneuropathie',
    title: 'Neuropathie, polyneuropathie',
    image: `${UPLOADS}/2023/05/depositphotos_41190329-stock-photo-foot-pain.webp`,
    description: [
      'Neuropathische pijn is zenuwpijn, bijvoorbeeld na gordelroos, bij CRPS (dystrofie), bij diabetes of na chemotherapie, amputatie, bestraling of verwonding.',
    ],
    treatmentSlugs: ['qutenza', 'lidocaine-intraveneus', 'ketamine-infuus', 'iontoforese', 'tens', 'medicatie-neuropathische-pijn'],
  },
];
